export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/identity.js
// module id = 431
// module chunks = 0 1 2 3 4